import React from 'react';

import * as MEDIA from '../../components/genericBrandLandingPageMedia'

// @mui
import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(({
    root: {
        height: '397px',
        margin: '32px auto 0',
        maxWidth: '707px',
    },
    video: {
        borderRadius: '4px',
        height: '100%',
        width: '100%',
    },
}));

const GenericBrandLandingPageVideo = (props) => {
    const { className } = props;
    const classes = useStyles();
    
    return (
        <React.Fragment>
            <Typography variant="h2" color="textPrimary">Te ayudamos a cumplir tus metas</Typography>
            <Box className={`${classes.root} ${className}`}>
                <video className={classes.video} src={MEDIA.getBrandLandingPagesVideo('unid')} controls controlsList="nodownload"></video>
            </Box>
        </React.Fragment>
    )
};

export default GenericBrandLandingPageVideo;